import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { Link } from 'react-router';
import { withTranslation } from 'react-i18next';

import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import LogoList from '../../components/LogoList';
import NavBar from '../../components/NavBar';
import UploadModal from '../../components/UploadModal';
import ViewLarge from '../modals/ViewLarge';
import RemoveLogo from '../modals/RemoveLogo';
import {
  UPLOAD_LOGO_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import Form from './Form';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      selectedLogo: null,
      showLarge: false,
      showDelete: false,
      logos: [],
    };
    this.logoList = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getToken(id, callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/logos/${id}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
  }
  handleRefetch() {
    this.logoList.getWrappedInstance().handleRefetch();
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedLogo: null,
    });
  }
  handleViewLarge = (e, selectedLogo) => {
    e.preventDefault();
    this.setState({
      selectedLogo,
      showLarge: true,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
      selectedLogo: null,
    });
  }
  handleDelete = (e, selectedLogo) => {
    e.preventDefault();
    this.setState({
      selectedLogo,
      showDelete: true,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
    }, () => {
      this.deleteLogos();
    });
  }
  async uploadLogo(e, body) {
    e.preventDefault();
    const { t } = this.props;
    const { store } = this.context;
    try {
      await this.form.getWrappedInstance().submit('/logos/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.props.token,
        },
        body,
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.uploadModal.close();
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Upload Success', { ns: TRANSLATION_FILES.translation }), message: t('Logo(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }) }));
  }
  deleteLogos() {
    const { t } = this.props;
    const { store } = this.context;
    this.getToken(this.state.selectedLogo.id, (token) => {
      store.dispatch(fetchM(`/logos/${this.state.selectedLogo.id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
      }))
        .then(() => {
          this.setState({
            selectedLogo: null,
            loading: false,
          });
          this.handleRefetch();
          store.dispatch(flashSuccessMessage({ header: t('Delete Success', { ns: TRANSLATION_FILES.translation }), message: t('Logo successfully deleted', { ns: TRANSLATION_FILES.translation }) }));
        })
        .catch((err) => {
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form.getWrappedInstance().state.uploads.length > 0) {
      const callback = () => {
        this.uploadModal.close();
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_LOGO_PROMPT), callback }));
      return true;
    }
    return false;
  }
  handleGetLogos = (logos) => {
    this.setState({ logos });
  }
  handleSlideLogo = (e, direction = 'right') => {
    const { logos, selectedLogo } = this.state;
    const index = logos.indexOf(selectedLogo);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedLogo: logos[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { logos, selectedLogo } = this.state;
    if (selectedLogo) {
      const index = logos.indexOf(selectedLogo);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < logos.length;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Logos')}
          rightNav={
            <Menu.Item fitted>
              <UploadModal
                ref={(ref) => { this.uploadModal = ref; }}
                header="Logos"
                loading={this.state.loading}
                onConfirm={(e, data) => {
                  this.uploadLogo(e, data);
                }}
                onClose={this.handleCheckBeforeClose}
                content={({ onConfirm }) => (
                  <Form
                    ref={(ref) => { this.form = ref; }}
                    onSubmit={onConfirm}
                  />
                )}
              />
            </Menu.Item>
          }
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedLogo}
          onSlide={this.handleSlideLogo}
          disabledLeft={!this.checkDisabled('left')}
          disabledRight={!this.checkDisabled('right')}
          slideshow={this.state.showLarge}
          pictureSize={100}
          extension="png"
        />
        <RemoveLogo
          open={this.state.showDelete}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          picture={this.state.selectedLogo}
          pictureSize={50}
          extension="png"
        />
        <LogoList
          ref={(ref) => { this.logoList = ref; }}
          toggleable
          onChange={this.handleGetLogos}
          onViewLarge={this.handleViewLarge}
          onRemove={this.handleDelete}
          buttonNode={({ isMobile, view, loading, logo }) => (
            view === 'list' ? (
              <div>
                <Button
                  as={Link}
                  size="tiny"
                  compact
                  primary
                  icon="edit"
                  content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                  disabled={loading}
                  to={`/media/logos/${logo.id}/`}
                />
                <Button
                  size="tiny"
                  compact
                  negative
                  icon="remove"
                  content={isMobile ? null : t('Remove')}
                  disabled={loading}
                  onClick={e => this.handleDelete(e, logo)}
                />
              </div>
            ) : (
              <Button
                as={Link}
                compact size="small"
                attached="bottom"
                primary
                icon="edit"
                content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                disabled={loading}
                to={`/media/logos/${logo.id}/`}
              />
            )
          )}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/Logos/List.jsx